<template>
  <div class="flex items-center">
    <Button variant="paper-primary" size="sm" class="mr-3" type="button" @click="goBack">
      <template #icon>
        <Icon name="ChevronLeft" class="h-4 w-4" />
      </template>
    </Button>

    <Icon
      @click="router.push('/dashboard')"
      name="House"
      class="h-3 w-3 mr-2 stroke-outline-dark cursor-pointer"
    />

    <div class="w-[7.008px] h-[2px] flex bg-outline-dark mr-2"></div>

    <div
      v-for="(crumb, index) in crumbs"
      :key="index"
      class="flex items-center cursor-pointer"
      @click="router.push(crumb.path)"
    >
      <span
        class="mr-2 text-sm font-inter"
        :class="crumb.path === full_path ? 'font-semibold text-strongest' : 'text-strong'"
      >
        {{ crumb.is_id ? `${crumb.name.slice(0, 8)}` : crumb.name }}
      </span>

      <span
        v-if="index !== crumbs.length - 1"
        class="w-[7.008px] h-[2px] flex bg-outline-dark mr-2"
      />
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useRouter, useRoute } from "vue-router";
import { Button, Icon } from "@/components";

const router = useRouter();
const route = useRoute();

const full_path = computed(() => route.fullPath);

const current_crumb = computed(() => {
  return props.crumbs.find((crumb) => crumb.path === full_path.value);
});

const current_crumb_index = computed(() => {
  return props.crumbs.findIndex((crumb) => crumb.path === full_path.value);
});

const props = defineProps({
  crumbs: {
    type: Array,
    required: true,
  },
});

// function goBack_old() {
//   if (window.history.length > 1) router.back();
//   else if (props.crumbs.length > 1)
//     // go to second last crumb
//     router.push(props.crumbs[props.crumbs.length - 2].path);
//   else router.push("/dashboard");
// }

function goBack() {
  // go to previous crumb in the list
  if (current_crumb_index.value > 0) router.push(props.crumbs[current_crumb_index.value - 1].path);
  // otherwise go to dashboard
  else router.push("/dashboard");
}
</script>
